/**
 * Zeitleiste der Version 10 „Lenas Werdegang“. Jede Station gehört zu einem
 * Eintrag im Lebenslauf (`ch`). Die ids der Produkt-Stationen sind dieselben
 * wie in v3/beats.js, so laufen die Panels aus v3 und v9 über
 * `BeatsProvider` mit. `len` ist die Länge in vh, `cam` die Kamera auf dem
 * Spielbrett: Weltpunkt x/y, Zoom z, und fx als horizontale Lage des
 * Weltpunkts auf dem Bildschirm (Desktop). `t` ist der Zeitpunkt innerhalb
 * der Station, an dem die Kamera dort ankommt. `m` überschreibt Werte auf
 * schmalen Screens (x, y, z und fy als vertikale Lage).
 */

// Orte auf dem Spielbrett (Weltkoordinaten, 2400 × 1500)
export const SPOT = {
  cs: { x: 620, y: 560 },
  hr: { x: 1290, y: 520 },
  reach: { x: 1980, y: 480 },
  arena: { x: 1250, y: 1090 },
  pool: { x: 1990, y: 1110 },
  sales: { x: 560, y: 1120 }
}

const at = (spot, z, fx = 0.38, dx = 0, dy = 0) => ({
  x: SPOT[spot].x + dx,
  y: SPOT[spot].y + dy,
  z,
  fx
})

const RAW = [
  {
    id: 'intro',
    ch: 'feb',
    len: 110,
    cam: [{ t: 0, x: 1260, y: 800, z: 0.5, fx: 0.5, m: { z: 0.42 } }]
  },
  {
    id: 'luecke',
    ch: 'feb',
    len: 190,
    cam: [
      { t: 0.25, ...at('cs', 1.25, 0.56, 0, -40) },
      { t: 0.7, x: 950, y: 540, z: 0.92, fx: 0.56, m: { z: 0.72 } }
    ]
  },
  { id: 'hr', ch: 'mar', len: 160, cam: [{ t: 0.2, ...at('hr', 1.2) }] },
  {
    id: 'analyse',
    ch: 'mar',
    len: 190,
    cam: [{ t: 0.2, ...at('cs', 1.1, 0.36, 60) }]
  },
  {
    id: 'profil',
    ch: 'mar',
    len: 170,
    cam: [{ t: 0.2, ...at('cs', 1.25, 0.36, 40, -50) }]
  },
  {
    id: 'link',
    ch: 'apr',
    len: 180,
    cam: [{ t: 0.22, ...at('reach', 1.1, 0.36) }]
  },
  {
    id: 'flut',
    ch: 'apr',
    len: 200,
    cam: [
      { t: 0.18, ...at('hr', 1.05, 0.56, 0, -40) },
      { t: 0.8, ...at('hr', 1.35, 0.56, 0, 10) }
    ]
  },
  {
    id: 'games',
    ch: 'mai',
    len: 190,
    cam: [{ t: 0.22, ...at('arena', 1.05, 0.36), m: { z: 0.95 } }]
  },
  {
    id: 'talente',
    ch: 'mai',
    len: 150,
    cam: [{ t: 0.2, ...at('arena', 1.2, 0.36, 60) }]
  },
  {
    id: 'magic',
    ch: 'mai',
    len: 170,
    cam: [{ t: 0.2, ...at('arena', 1.15, 0.38, -40) }]
  },
  {
    id: 'liste',
    ch: 'mai',
    len: 170,
    cam: [{ t: 0.2, ...at('arena', 1.15, 0.36, 40, 10), m: { x: 1255, z: 1 } }]
  },
  {
    id: 'regeln',
    ch: 'mai',
    len: 140,
    cam: [
      {
        t: 0.2,
        x: 1060,
        y: 1060,
        z: 1.35,
        fx: 0.32,
        m: { x: 1120, y: 1150, z: 1.1 }
      }
    ]
  },
  {
    id: 'report',
    ch: 'jun',
    len: 200,
    cam: [{ t: 0.22, ...at('hr', 1.25, 0.36) }]
  },
  {
    id: 'gespraech',
    ch: 'jun',
    len: 170,
    cam: [{ t: 0.2, ...at('hr', 1.45, 0.38, 30, 20) }]
  },
  {
    id: 'team',
    ch: 'jun',
    len: 190,
    cam: [{ t: 0.22, ...at('cs', 1.2, 0.36, 40, -40) }]
  },
  {
    id: 'kreuz',
    ch: 'jun',
    len: 170,
    cam: [{ t: 0.2, x: 700, y: 1110, z: 1.05, fx: 0.36 }]
  },
  {
    id: 'absagen',
    ch: 'jun',
    len: 170,
    cam: [{ t: 0.2, x: 1800, y: 1120, z: 0.95, fx: 0.3 }]
  },
  { id: 'ats', ch: 'jun', len: 150, cam: [{ t: 0.2, ...at('hr', 1.25) }] },
  {
    id: 'start',
    ch: 'jul',
    len: 190,
    cam: [
      { t: 0.25, x: 950, y: 540, z: 0.95, fx: 0.56 },
      { t: 0.6, ...at('cs', 1.4, 0.56, 40, -80) }
    ]
  },
  {
    id: 'wachsen',
    ch: 'jahr',
    len: 220,
    cam: [{ t: 0.2, ...at('cs', 1.3, 0.36, 60, -60) }]
  },
  {
    id: 'pool',
    ch: 'jahr',
    len: 200,
    cam: [
      { t: 0.22, x: 1500, y: 700, z: 0.56, fx: 0.55, m: { x: 1450, z: 0.5 } }
    ]
  },
  {
    id: 'support',
    ch: 'jahr',
    len: 130,
    cam: [{ t: 0.2, ...at('hr', 1.3) }]
  },
  {
    id: 'finale',
    ch: 'end',
    len: 190,
    cam: [
      { t: 0.25, x: 1240, y: 820, z: 0.52, fx: 0.62, m: { z: 0.6, fy: 0.68 } }
    ]
  }
]

export const CHAPTERS = [
  { id: 'feb', date: 'Februar 2025', title: 'Eine Lücke im Team' },
  { id: 'mar', date: 'März', title: 'Die Stelle bekommt ein Profil' },
  { id: 'apr', date: 'April', title: 'Die Suche' },
  { id: 'mai', date: 'Mai', title: 'Das Assessment' },
  { id: 'jun', date: 'Juni', title: 'Die Entscheidung' },
  { id: 'jul', date: 'Juli', title: 'Der erste Tag' },
  { id: 'jahr', date: 'Ein Jahr später', title: 'Lena wächst' }
]

export const TOTAL_VH = RAW.reduce((sum, b) => sum + b.len, 0)

export const BEATS = RAW.reduce((list, b) => {
  const start = list.length ? list[list.length - 1].at[1] : 0
  list.push({ ...b, at: [start, start + b.len / TOTAL_VH] })
  return list
}, [])

const B = Object.fromEntries(BEATS.map((b) => [b.id, b.at]))

export const inB = (beat, a, b) => {
  const [s, e] = B[beat]
  const len = e - s
  return [s + a * len, s + b * len]
}

export const atB = (beat, a) => inB(beat, a, a)[0]

// Kamera als Schlüsselbilder über die ganze Section. Jede Station hält ihr
// letztes Bild bis zum Ende, die Fahrt zur nächsten beginnt mit ihr.
export const CAMERA = BEATS.flatMap((b) => {
  const keys = b.cam.map(({ m = {}, ...c }) => ({
    ...c,
    l: atB(b.id, c.t),
    mx: m.x ?? c.x,
    my: m.y ?? c.y,
    mz: m.z ?? c.z,
    mfy: m.fy ?? 0.38
  }))
  const last = keys[keys.length - 1]
  return [...keys, { ...last, l: b.at[1] }]
})
